<template>
  <div class="experience-box-container">
    <div class="entry-container" @click="toggleVisible">
      <div class="experience-box-entry"></div>
      <div class="experience-box-title">经历库</div>
    </div>
    <transition name="el-fade-in-linear">
      <div v-if="visible" class="experience-block-container">
        <div class="experience-tabs-container flex items-center">
          <div
            class="experience-tabs-item flex-1 flex items-center justify-center"
            :class="{ active: activeIndex === 0 }"
            @click="activeIndex = 0"
          >
            <span>我的经历</span>
          </div>
          <div
            class="experience-tabs-item flex-1 flex items-center justify-center"
            :class="{ active: activeIndex === 1 }"
            @click="activeIndex = 1"
          >
            <span>大牛经历</span>
          </div>
        </div>
        <div v-show="activeIndex === 0" class="experience-list-container">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="experience-item"
          >
            <div class="experience-item-title" @click="clickChecked(item)">
              {{ item.title }}
              <template v-if="item.type !== 'extras'">
                （{{ item.experiences.length }}）
              </template>
              <i
                class="iconfont"
                :class="item.checked ? 'iconshangla' : 'iconxiala'"
              ></i>
            </div>
            <div v-show="item.checked" class="experiences-content">
              <template v-if="item.type === 'extras'">
                <div
                  v-for="(extrasKey, extrasKeyIndex) in returnExtrasKeys(
                    item.experiences
                  )"
                  :key="extrasKeyIndex"
                  class="extras-item-content"
                >
                  <div class="extras-title" style="margin-bottom: 16px">
                    {{ returnExtraItemTitle(extrasKey) }}
                  </div>
                  <ExperienceItem
                    v-for="(extra, extraIndex) in item.experiences[extrasKey]"
                    :key="extraIndex"
                    :experience="extra"
                    :hidden-title="true"
                  />
                </div>
              </template>
              <template
                v-else
                v-for="(experience, experienceIndex) in item.experiences"
              >
                <ExperienceItem
                  :key="experienceIndex"
                  :experience="experience"
                />
              </template>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { mapState } from "vuex";
import ExperienceItem from "./ExperienceItem.vue";
export default {
  name: "ExperienceBox",
  components: {
    ExperienceItem,
  },
  data() {
    return {
      visible: false,
      activeIndex: 0,
      otherTitle: {
        certificates: "证书/执照：",
        interests: "兴趣爱好：",
        languages: "语言能力：",
        others: "活动项目：",
        skills: "技能：",
      },
    };
  },
  computed: {
    ...mapState("experience", ["experienceTitleList", "experienceList"]),
    list() {
      return this.experienceTitleList.map((item) => ({
        ...item,
        experiences: this.returnExperienceList(item.type),
        checked: true,
      }));
    },
  },
  methods: {
    toggleVisible() {
      this.visible = !this.visible;
    },
    returnExperienceList(type) {
      return this.experienceList[type];
    },
    clickChecked(item) {
      item.checked = !item.checked;
      this.$forceUpdate();
    },
    returnExtraItemTitle(type) {
      return this.otherTitle[type];
    },
    returnExtrasKeys(experiences) {
      return Object.keys(experiences);
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/css/variable.scss";

.experience-box-container {
  .entry-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: fixed;
    right: 30px;
    bottom: 154px;
    color: #fff;
    cursor: pointer;
    z-index: 21;
    .experience-box-entry {
      width: 50px;
      height: 50px;
      background-image: url("https://files.wondercv.com/PC/editor/jingliku.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    .experience-box-title {
      font-size: 12px;
      font-weight: 400;
      line-height: 12px;
      margin-top: 12px;
      color: $text-color;
    }
  }
  .experience-block-container {
    position: fixed;
    top: 72px;
    right: 30px;
    bottom: 22px;
    width: 526px;
    height: calc(100vh - 94px);
    background-color: $page-bg-sub-color;
    border-radius: 6px;
    box-sizing: border-box;
    .experience-tabs-container {
      height: 54px;
      .experience-tabs-item {
        @apply relative cursor-pointer h-full;
        background-color: $page-bg-sub-color;
        color: $experience-tab-default-color;
        &:not(:last-child)::after {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translateY(-50%);
          content: "";
          display: inline-block;
          width: 1px;
          height: 18px;
          background-color: $experience-after-color;
        }
        &.active {
          background-color: $page-bg-sub-color;
          span {
            background: linear-gradient(180deg, #e15d3f 0%, #febf5d 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          &::before {
            content: "";
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: calc(100% - 40px);
            height: 2px;
            background: linear-gradient(270deg, #e15d3f 0%, #febf5d 100%);
          }
        }
      }
    }
    .experience-list-container {
      height: calc(100% - 54px);
      padding: 0 16px;
      overflow: scroll;
      &::-webkit-scrollbar {
        display: none;
      }
      .experience-item {
        &:first-child {
          margin-top: 24px;
        }
        &:last-child {
          margin-bottom: 50px;
        }
        .experience-item-title {
          @apply flex items-center font-medium cursor-pointer;
          color: $text-color;
          border: 1px solid $select-border-color;
          background: linear-gradient(
            45deg,
            $experience-title-bg-start 0%,
            $experience-title-bg-start 62%,
            $experience-title-bg-end 100%
          );
          padding: 0 16px;
          height: 36px;
          width: fit-content;
          margin-bottom: 16px;
          border-radius: 18px;
          i {
            font-size: 14px;
            margin-left: 8px;
          }
        }
        .experiences-content {
          .extras-title {
            color: $text-color;
          }
        }
      }
    }
  }
}
</style>
